import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import unimedLogo from '../../assets/images/logo-unimed-campinas.svg';


const BoletoWelcome: React.FC = () => {

  const navigate = useNavigate();

  const { textStyleAccessibility, contrastMode } = useAccessibility();

  return (
    <div className='width-100'>
      {
        contrastMode ?
          <h1 style={textStyleAccessibility} className='boleto-unimed-logo'>Unimed<br />Campinas</h1>
          :
          <img src={unimedLogo} width={'227px'} height={'85px'} alt="Logo Unimed" className='boleto-unimed-logo' />
      }
      <div className='container-boleto-painel-left'>
        <span style={textStyleAccessibility} className='boleto-painel-left-title'>
        Emissão de 2ª<span className="line-break">via de boleto</span>
        </span>
        <span style={textStyleAccessibility} className='boleto-painel-left-subtitle margin-bottom'>Bem-vindo(a)!</span>
        <span style={textStyleAccessibility} className='boleto-text'>Aqui você pode reemitir seus boletos de<br /> cobranças que tenham sido emitidos pelo<br /> Unimed Campinas.</span>
      </div>
    </div>
  );
};

export default BoletoWelcome;
